import { useEffect, useState } from 'react';
import '../assets/css/dialog.css';
import pluma from '../assets/img/gif/pluma.gif'

import progress from '../assets/img/gif/progres.gif'





function Dialog(props) {
    function close() {
        document.getElementsByClassName("dialog")[0].remove();
    }
    useEffect(() => {

    }, []);
    return (
        <div class="dialog">
            <div class="pergamino">
                <div style={{ textAlign: "end"}}><i class="fas fa-times-circle" onClick={close}></i ></div>
                <p id="mensaje" style={{ textAlign: "justify" }} ></p>
                <div style={{ display: "flex", justifyContent: "end" }}>
                    <img src={pluma} class="img-responsive pluma"></img>
                </div>

            </div>
        </div>
    );
}

export default Dialog;